import React from 'react';
import { connect } from 'react-redux';
import { Alert, Button, Checkbox, Glyphicon } from 'react-bootstrap';
import { LoaderButton, ContinueLabel, WithModal } from 'ctia-ui';
import AgreementsModal from 'containers/request/Initial/Agreements/AgreementsModal';
import VendorAgreementContent from 'containers/request/Initial/Agreements/VendorAgreementContent';
import { signVendorAgreement, getUserInfo } from 'actions/user';

class SignVendorAgreement extends WithModal {
  state = { ...this.state, signed: false, isLoading: false };

  handleCheckbox = event => {
    this.setState({
      signed: event.target.checked
    });
  };

  onPrintClick = () => {
    document.getElementById('vendorAgreementLink').click();
  };

  finishLoading = () => {
    this.setState({ isLoading: false });
  };

  onSign = () => {
    this.setState({ isLoading: true });
    const { signVendorAgreement, getUserInfo } = this.props;
    signVendorAgreement(getUserInfo, this.finishLoading);
  };

  render() {
    const { signed, showModal, isLoading } = this.state;
    return (
      <div>
        <h1>Vendor Participation Agreement</h1>
        <Alert bsStyle="warning">
          Prior to initiating OnGo Certification for any device(s), the Vendor
          Participation Agreement, which outlines the roles, responsibilities,
          and legal obligations of the CBRS Alliance and Vendor requesting
          certification, must be agreed upon.
        </Alert>
        <div className="text-center">
          <Button bsStyle="warning" onClick={this.handleModal}>
            <Glyphicon glyph="zoom-in" /> Review the Vendor Participation
            Agreement
          </Button>
          <Checkbox
            id="vendorAgreementAccepted"
            onChange={this.handleCheckbox}
            value={signed}
            checked={signed}
            disabled={false}
          >
            <strong>
              I accept the Vendor Participation Agreement terms and conditions
            </strong>
          </Checkbox>
        </div>
        <AgreementsModal
          title="Vendor Participation Agreement"
          show={showModal}
          modalHandler={this.handleModal}
          content={VendorAgreementContent}
          downloadHandler={this.onPrintClick}
          actionIcon="download-alt"
          actionTitle="Download as PDF"
        />
        <div id="hiddenLink">
          <a
            href="/pdf/CBRS Alliance Vendor Participation Agreement.pdf"
            target="_blank"
            id="vendorAgreementLink"
          >
            Download Vendor Agreement
          </a>
        </div>
        <hr />
        <div className="text-right">
          <LoaderButton
            bsStyle="info"
            text={<ContinueLabel />}
            disabled={!signed}
            isLoading={isLoading}
            onClick={this.onSign}
          />
        </div>
      </div>
    );
  }
}

export default connect(
  null,
  { signVendorAgreement, getUserInfo }
)(SignVendorAgreement);



// WEBPACK FOOTER //
// ./src/containers/request/SignVendorAgreement.js